import { useSelector } from 'react-redux';
import { Box, FormControl, MenuItem, Link, Select, Typography } from '@mui/material';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import '../../common/theme/CommonStyles.scss';
import './UserSelect.scss';

const UserSelectComponent = ({ handleChange, selectedUser }) => {
  const plusIcon = require('../../img/plus-icon.png');
  const enrollments = useSelector((state) => state.enrollments);

  var currentUser = enrollments.find(item => item.prismId === selectedUser.new);
  if (currentUser) {
    const indexValue = enrollments.indexOf(currentUser);
    enrollments.splice(indexValue, 1);
    enrollments.unshift(currentUser);
  };
    return (
      <Box className='userSelect'>
        <Box className='userSelectCard'>
          <Typography className='userSelect-title'>Username selection</Typography>
            <Box className='sub-message'>Switch between usernames to access different accounts.</Box>
          <form>
          <Box className='userSelect-field'>
               <FormControl className='product-select' variant='outlined'>
                <Select
                  className='userSelect-caret'
                  sx={{
                    '& .MuiSvgIcon-root': {
                      color: '#282828',
                    },
                  }}  
                  IconComponent={KeyboardArrowDown}
                  onChange={handleChange}                    
                  displayEmpty
                  value={currentUser ? currentUser.prismId : ""}
                  inputProps={{ 'aria-label': 'Without label' }}
                  renderValue={
                    selected => selected !== "" ? selected : ( <span className="placeholder-text">{currentUser ? currentUser.prismId : ''}</span> )
                  }
                >
                  {enrollments && enrollments.map((data) => (
                    <MenuItem disableRipple className='dropdown-option' key={data.prismId} value={data.prismId}>
                      {data.prismId}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Box className='add-user'>
                <Link
                  href='/add-user'
                  className='button-styling add-user-link'
                >
                  <img className='plus-icon' src={plusIcon} alt='add'/>
                  <span className='amig-h6-web-text'>Add username</span>
                </Link>
              </Box>
            </Box>
          </form>
        </Box>
      </Box>
    );

  }

export default UserSelectComponent